// @ts-nocheck
import LazyImage from "@insite/mobius/LazyImage";
import useSignatureData from "@store/Framework/Common/Hooks/useSignatureData";
import { CustomWidgetModule } from "@store/Framework/Types/types";
import React from "react";

const SignaturePreview = () => {
    const { signatureData } = useSignatureData();
    return signatureData.customerEmail ? (
        <LazyImage height="40px" width="100px" src={signatureData.customerSignature} altText="Signature" />
    ) : null;
};

const widgetModule: CustomWidgetModule = {
    component: SignaturePreview,
    definition: {
        group: "SignaturePad",
    },
};

export default widgetModule;
